module.exports = __webpack_public_path__ + "img/cancel.9def105d.svg";